import * as React from "react";
import { IReport4Presenter } from "../../../presenter/report/Report4Presenter";
import { Divider, Typography, Icon } from "antd";
import PDFExportLink from "../../components/app/PDFExportLink";
import ReportPreview from "../../components/app/ReportPreview";
import Report4ParamBox from "../../components/report/Report4ParamBox";

export interface Props {}

export interface State extends IReport4Presenter {}

export default class Report4Page extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      report4ReportingPeriodList,
      onChangeReportingPeriod,
      report4CurrentReportingPeriod,
      report4RiskCriteria,
      translate,
      getPDFReport4,
      report4,
      report4SelectedRiskCriteriaIds,
      onRiskCriteriaChange
    } = this.state;

    const _selectedRiskCriteriaPath = report4SelectedRiskCriteriaIds
      ?.map(i => "&riskCriterionList=" + i)
      .join()
      .replace(",", "")
      .slice(1);
    return (
      <div className={"report-container"}>
        <Report4ParamBox
          currentReportingPeriod={report4CurrentReportingPeriod}
          reportingPeriodList={report4ReportingPeriodList}
          onChangeReportingPeriod={onChangeReportingPeriod}
          getPDFReport={getPDFReport4}
          translate={translate}
          riskCriteria={report4RiskCriteria}
          loading={this.state.loaders.report4Loader}
          onRiskCriteriaChange={onRiskCriteriaChange}
          title={translate("reports.params.reporting_period")}
          selectedRiskCriteriaIds={report4SelectedRiskCriteriaIds}
        />
        <Divider type={"vertical"} style={{ height: "100%" }} />
        {report4 && (
          <div style={{ width: "75%", paddingLeft: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <Typography.Title style={{ fontSize: 14 }}>
                {translate("reports.review_report")}
              </Typography.Title>
              <div>
                {!this.state.loaders.report4Loader && (
                  <PDFExportLink
                    translate={translate}
                    data={report4}
                    title={report4CurrentReportingPeriod?.name}
                    subtitle={translate("reports.report_4")}
                    fileName={`${translate("reports.report_4")}.pdf`}
                  />
                )}
                <Divider
                  type={"vertical"}
                  style={{ fontSize: 10, height: "100%" }}
                />
                <a
                  key="file-excel"
                  href={`/api/reports/report4/reporting-periods/${report4CurrentReportingPeriod?.id}/xlsx/?${_selectedRiskCriteriaPath}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon
                    type="file-excel"
                    theme={"outlined"}
                    style={{ fontSize: 20, color: "#20744B" }}
                  />
                </a>
              </div>
            </div>
            <Divider type={"horizontal"} />
            <ReportPreview
              translate={translate}
              data={report4}
              title={report4CurrentReportingPeriod?.name}
              subtitle={translate("reports.report_4")}
            />
          </div>
        )}
      </div>
    );
  }
}
